module.exports = __webpack_public_path__ + "img/ch36.1c020a49.jpg";